import { render, staticRenderFns } from "./LeadOutcomes.vue?vue&type=template&id=20ecaa61&scoped=true"
import script from "./LeadOutcomes.vue?vue&type=script&lang=js"
export * from "./LeadOutcomes.vue?vue&type=script&lang=js"
import style0 from "./LeadOutcomes.vue?vue&type=style&index=0&id=20ecaa61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ecaa61",
  null
  
)

export default component.exports